export default "__VITE_ASSET__d560a5d5__"